import { render, staticRenderFns } from "./UserDetails.vue?vue&type=template&id=526357f6&scoped=true"
import script from "./UserDetails.vue?vue&type=script&lang=js"
export * from "./UserDetails.vue?vue&type=script&lang=js"
import style0 from "./UserDetails.vue?vue&type=style&index=0&id=526357f6&prod&scoped=true&lang=css"
import style1 from "./UserDetails.vue?vue&type=style&index=1&id=526357f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526357f6",
  null
  
)

export default component.exports